import View from 'ol/View';
import { getForViewAndSize } from 'ol/extent';

import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';

export class MapView extends View {

  getViewportSize () {
    // @ts-ignore - accessing this private field is intentional
    return super.getViewportSize_();
  }

  getViewportSizeMinusPadding () {
    // @ts-ignore - accessing this private field is intentional
    return super.getViewportSizeMinusPadding_();
  }

  /**
   * Same as ol.View.calculateExtent, which subtracts the padding from the extent. Prefer to use
   * this method or calculateFullExtent depending on the use case to be clear about the intention,
   * as the OL implementation might change.
   *
   * Part of the map is overlaid by the map toolbar. ol.View.calculateExtent previously returned the whole extent including the invisible part,
   * since  https://github.com/openlayers/openlayers/commit/900107df1d05e113e0146068718e686c8c0a8eee it now subtracts the padding.
   * Use this method to calculate only the visible extent.
   *
   * Be sure to use ol.Map#getInnerSize() together with this method ol.View#calculateVisibleExtent() in case only a visible extent is required.
   * If the whole displayed extent is wanted (including the area under map toolbar). use ol.Map#getSize() together with this method this#calculateFullExtent()
   * Attention: [13.01.2021] ol.View#calculateExtent() with no arguments in ol version 6.5.0 will return a completely wrong extent (see https://github.com/openlayers/openlayers/issues/11936)
   *
   * @return Extent of the view with padding excluded
   */
  calculateVisibleExtent () {
    // we use a more precise type for OL's Extent
    return super.calculateExtent(this.getViewportSizeMinusPadding()) as WorldBoxDto;
  }

  /**
   * See this#calculateVisibleExtent() for details. CalculateFullExtent() will return the map extent
   * without subtracting eventual padding, thus the extent is greater than the one visible to the user.
   * It works together with ol.Map#getSize()
   *
   * @return Extent of the full view without subtracting padding
   */
  calculateFullExtent () {
    // ol.View.getState() returns a center of a full viewport.
    // ol.View.getCenter() cannot be used here, as it gives a center of a visible extent, which might differ from the full viewport center.
    const { center, resolution, rotation } = this.getState();
    const size = this.getViewportSize();
    // we use a more precise type for OL's Extent
    return getForViewAndSize(center, resolution, rotation, size) as WorldBoxDto;
  }

}

